import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    clientAuthorization(ctx, { token }) {
      return new Promise((resolve, reject) => {
        // console.log(`${widgetApiUrl}/client/${token}`)
        axios
          .post('/auth/client', { token })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
